import axios from 'axios';
import { env } from '@/lib/env';
import { useAuthStore } from '@/state/authStore';

export const api = axios.create({
  baseURL: env.VITE_API_BASE_URL,
  timeout: 30_000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor: JWT 付与
api.interceptors.request.use((config) => {
  const token = useAuthStore.getState().accessToken;
  if (token) {
    config.headers.set('Authorization', `Bearer ${token}`);
  }
  return config;
});

// Response interceptor: 401 で強制ログアウト + 5xx/network 統一メッセージ
api.interceptors.response.use(
  (resp) => resp,
  (error) => {
    const status = error.response?.status;
    if (status === 401) {
      useAuthStore.getState().clear();
      // Cognito Hosted UI へのリダイレクトは features/auth/cognitoClient.ts で行う
      window.location.href = '/login';
    } else if (status >= 500) {
      error.userMessage = `サーバーエラーが発生しました (HTTP ${status})。しばらくしてから再度お試しください。`;
      console.error('[API 5xx]', error.config?.url, status, error.response?.data);
    } else if (!error.response) {
      error.userMessage = 'ネットワークエラーが発生しました。接続をご確認ください。';
      console.error('[API network]', error.config?.url, error.message);
    } else if (status >= 400) {
      const detail = error.response?.data?.detail;
      error.userMessage =
        typeof detail === 'string' ? detail : `リクエストエラー (HTTP ${status})`;
    }
    return Promise.reject(error);
  },
);
